// #region --------- GLOBALES QUE SUELEN ESTAR EN TODOS LOS MODULES -------------
// #region Librerias que se utilizan casi siempre
import { FormsModule, NG_VALIDATORS, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
// #endregion Librerias que se utilizan casi siempre
// #region Validadores
import { nifValidator } from './validators/nif-validator.validator';
import { arrayValidator } from './validators/array-validator.validator';
import { cifValidator } from './validators/cif-validator.validator';
// #endregion Validadores
// #endregion --------- GLOBALES QUE SUELEN ESTAR EN TODOS LOS MODULES -------------
// #region --------- EXCLUSIVOS APP.MODULE.TS -------------
// #region Componentes
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './components/login/login.component';
import { LoginService } from '../app/services/login.service';
import { LoginConductorComponent } from './components/login/login-conductor/login-conductor.component';
import { OlvidoPasswordComponent } from './components/login/olvido-password/olvido-password.component';
import { RegistroUsuarioComponent } from './components/login/registro-usuario/registro-usuario.component';
import { TerminosYCondicionesComponent } from './components/terminos-y-condiciones/terminos-y-condiciones.component';
import { ActivityService } from './services/user-activity.service';
export function initActivity(svc: ActivityService) {
  return () => svc.init();
}
// #endregion Componentes
// #region Environment
import { environment } from './../environments/environment';
// #endregion Environment
// #region Librerías
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPicaModule } from '@digitalascetic/ngx-pica';
import { NgxImageCompressService } from 'ngx-image-compress';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NgModule, NO_ERRORS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { createTranslationLoader } from './services/translation-loader';
import { ChartsModule } from 'ng2-charts';
// #endregion Librerías
// #region ModulesExternos
import { SharedModule } from './shared/shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { WaitingComponent } from './components/waiting/waiting.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { AngularMaterialModule } from './shared/angular-material/angular-material.module';
import { ComponentesAuxiliaresModule } from './components/componentesAuxiliares/componentes-auxiliares/componentes-auxiliares.module';
import { CommonModule } from '@angular/common';
import { LanguageService } from './services/language.service';
import { RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
// #region ModulesExternos
// #endregion --------- EXCLUSIVOS APP.MODULE.TS -------------

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    FooterComponent,
    LoginConductorComponent,
    TerminosYCondicionesComponent,
    OlvidoPasswordComponent,
    RegistroUsuarioComponent,
    WaitingComponent,
  ],
  imports: [
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    NgxPaginationModule,
    NgxDocViewerModule,
    ModalModule.forRoot(),
    NgxPicaModule,
    ChartsModule,
    NgxGalleryModule,
    SharedModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      progressAnimation: 'increasing',
      progressBar: true,
      preventDuplicates: true
    }),
    RouterModule,
    PdfJsViewerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    AngularMaterialModule,
    ComponentesAuxiliaresModule,
  ],
  providers: [
    LoginService,
    NgxImageCompressService,
    { provide: APP_INITIALIZER, useFactory: initLanguage, deps: [LanguageService], multi: true },
    { provide: RECAPTCHA_LANGUAGE, useFactory: recaptchaLanguage, deps: [LanguageService] },
    { provide: APP_INITIALIZER, useFactory: initActivity, deps: [ActivityService], multi: true },
    { provide: NG_VALIDATORS, useExisting: nifValidator, multi: true },
    { provide: NG_VALIDATORS, useExisting: arrayValidator, multi: true },
    { provide: NG_VALIDATORS, useExisting: cifValidator, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
  ],
  bootstrap: [
    AppComponent
  ],
  schemas: [NO_ERRORS_SCHEMA],
  entryComponents: [
    WaitingComponent
  ]
})
export class AppModule { }

export function initLanguage(language: LanguageService) {
  return () => language.initialize();
}

export function recaptchaLanguage(language: LanguageService): string {
  return language.currentLanguage;
}

export function httpTranslateLoader(http: HttpClient) {
  return createTranslationLoader(http, environment.traduccion);
}
